import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AnalyticsContext, Button, P, reportAction } from 'shared';
import logoADS from 'images/lenders/logo-ads.png';
import logoAFF from 'images/lenders/logo-aff.png';
import logoACI from 'images/lenders/logo-flex.png';
import logoImprint from 'images/lenders/logo-imprint.png';
import { setActiveOfferId, setLenderName, setOfferScreen } from '../actions';
import { OfferMoreDetails } from '.';
function OfferCard({ offer, selectOfferCallback }) {
    const dispatch = useDispatch();
    const { analytics } = useContext(AnalyticsContext);
    const { serviceProviderName } = offer;
    const lenderVariables = {
        ADS: {
            logo: logoADS,
            prequalifiedButtonClass: 'button-warn',
            otherButtonClass: 'button-warn-gray-outline',
        },
        Imprint: {
            logo: logoImprint,
            prequalifiedButtonClass: 'button-warn-advantage',
            otherButtonClass: 'button-warn-gray-advantage-outline',
        },
        AFF: {
            logo: logoAFF,
            prequalifiedButtonClass: 'button-warn',
            otherButtonClass: 'button-warn-outline',
        },
        ACI: {
            logo: logoACI,
            prequalifiedButtonClass: 'button-warn-alp-flex',
            otherButtonClass: 'button-warn-alp-flex-outline',
        },
    };
    const [showDetails, setShowDetails] = useState(false);
    const offerAmount = `$${offer.amount.toLocaleString()}`;
    const middleHtml = () => {
        if (offer.offerType === 'prequalified') {
            if (serviceProviderName === 'Imprint') {
                return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "status-and-amount", children: [_jsx(P, { variant: "body-medium", bold: true, className: "status-text", children: "Pre-qualified" }), _jsx(P, { variant: "title-extra-large", bold: true, className: "prequal-amount", children: offerAmount })] }), offer.downpaymentRequired && (_jsx(P, { variant: "body-small", className: "font-italic color-gray align-self-start", children: "Down payment due at signing" }))] }));
            }
            else {
                return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "status-and-amount", children: [_jsx(P, { variant: "body-medium", bold: true, className: "status-text", children: "Pre-qualified*" }), _jsx(P, { variant: "title-extra-large", bold: true, className: "prequal-amount", children: offerAmount })] }), _jsx("div", { className: "empty-disclaimer" })] }));
            }
        }
        else if (offer.offerType === 'not_prequalified' ||
            offer.offerType === 'disqualified') {
            return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "status-and-amount", children: [_jsx(P, { variant: "body-medium", className: "font-italic color-gray declined-text", children: "Not Pre-qualified" }), _jsx("div", { className: "empty-amount" })] }), _jsx("div", { className: "empty-disclaimer" })] }));
        }
        else if (offer.offerType == 'pending') {
            if (serviceProviderName === 'Imprint') {
                return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "status-and-amount", children: [_jsx(P, { variant: "body-medium", bold: true, className: "status-text", children: "Conditional Approval Amount" }), _jsx(P, { variant: "title-extra-large", bold: true, className: "prequal-amount", children: offerAmount })] }), _jsx("div", { className: "empty-disclaimer" })] }));
            }
            else {
                return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "status-and-amount", children: [_jsx(P, { variant: "body-medium", bold: true, className: "status-text", children: "Conditional Approval Amount" }), _jsx(P, { variant: "title-extra-large", bold: true, className: "prequal-amount", children: offerAmount })] }), _jsx("div", { className: "empty-disclaimer" })] }));
            }
        }
        else if (offer.offerType === 'step_up_pend') {
            return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "status-and-amount", children: [_jsx(P, { variant: "body-medium", className: "font-italic color-gray declined-text", children: "Additional Information Required" }), _jsx("div", { className: "empty-amount" })] }), _jsx("div", { className: "empty-disclaimer" })] }));
        }
    };
    const logToAnalytics = () => {
        analytics?.track('SelectOfferOnSeeMoreOffers', {
            lender: offer.serviceProviderName,
        });
        reportAction('SelectOfferOnSeeMoreOffers', {
            componentName: 'OfferCard',
            actionType: 'SelectOfferOnSeeMoreOffers',
            actionURL: window.location.pathname,
            actionData: {
                lender: offer.serviceProviderName,
            },
        });
    };
    const handleSelectOffer = () => {
        dispatch(setOfferScreen('PRESENTED OFFER'));
        dispatch(setActiveOfferId(offer.offerId));
        dispatch(setLenderName(offer.serviceProviderName));
        logToAnalytics();
        if (selectOfferCallback) {
            selectOfferCallback();
        }
    };
    return (_jsxs("div", { className: "offer-card box-shadow-glow border-none", children: [_jsxs("div", { className: "content-container", children: [_jsxs("div", { className: "logo-and-middle", children: [_jsx("img", { src: lenderVariables[offer.serviceProviderName].logo, alt: `Imprint logo` }), _jsx("div", { className: "middle-container", children: middleHtml() })] }), offer.offerType === 'prequalified' ? (_jsx(Button, { type: "button", onClick: handleSelectOffer, className: `button-warn ${lenderVariables[offer.serviceProviderName].prequalifiedButtonClass} qualify-lg`, children: _jsx("strong", { children: " CONTINUE WITH OFFER" }) })) : (_jsxs(_Fragment, { children: [serviceProviderName === 'ADS' && (_jsx(Button, { type: "button", className: `button-warn ${lenderVariables[offer.serviceProviderName].otherButtonClass} qualify-lg`, onClick: () => setShowDetails((prev) => !prev), children: _jsxs("strong", { children: [" ", showDetails ? 'HIDE' : 'SHOW', " DETAILS"] }) })), serviceProviderName === 'Imprint' &&
                                offer.offerType === 'step_up_pend' && (_jsx(Button, { type: "button", className: `button-warn ${lenderVariables[offer.serviceProviderName].otherButtonClass} qualify-lg`, onClick: () => setShowDetails((prev) => !prev), children: _jsxs("strong", { children: [" ", showDetails ? 'HIDE' : 'SHOW', " DETAILS"] }) }))] }))] }), showDetails && (_jsx("div", { className: "row horizontal-divider-top mar-t-20", children: _jsx(OfferMoreDetails, { offer: offer }) }))] }));
}
export default OfferCard;
